export default 'M4.59 15.58a2 2 0 1 1 2.82-2.82L10 15.34V3a2 2 0 0 1 4 0v12.34l2.59-2.58a2 2 0 1 1 2.82 2.82L12 23z';